import React from 'react'

function SmallSecondaryButton({ onClick, text,icon }) {
  return (
    <button className='font-medium justify-center rounded-[5px] py-2 px-3 text-sm border border-[#5B9ECF] text-[#5B9ECF] hover:bg-[#5B9ECF] hover:text-white flex items-center gap-2' onClick={() => onClick()}>{icon}{text}</button>
  )
}

export default SmallSecondaryButton